import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { APP_FORM_ERRORS } from '@utils/app-form-errors';
import { SessionService } from '@utils/services/session.service';
import { FormHelperService } from 'logical-growth-components';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastModule, ConfirmDialogModule],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'cobranzawebfianly';

  private readonly _sessionService = inject(SessionService);
  private readonly _formHelper = inject(FormHelperService);

  constructor() {
    window.addEventListener('storage', this._sessionService.storage_events_handler);
  }

  ngOnInit(): void {
    this._formHelper.setErrors(APP_FORM_ERRORS());
    this._sessionService.checkSession();
  }

  ngOnDestroy(): void {
    window.removeEventListener('storage', this._sessionService.storage_events_handler);
  }
}
